require('./jv.Admin.Users.Roles.List.Controller');
require('./jv.Admin.Users.Roles.Details.Controller');
require('./jv.Admin.Users.Roles.Service');
require('../../../common/directives/jv.RoleSelect');
require('../../../common/directives/jv.AccessGroupSelect');

angular.module('jv.Admin.Users.Roles.app', [
    'jv.Admin.Users.Roles.List.Controller',
    'jv.Admin.Users.Roles.Details.Controller',
    'jv.Admin.Users.Roles.Service',
    'jv.Common.RoleSelect',
    'jv.Common.AccessGroupSelect'
])
.value('jvPaginationTemplateUrl', jvUrls.admin + '/htm/common/pagination-template.html');
